import { __assign, __rest } from "tslib";
import { prepareApi } from '../../utils';
import { shareChannelMap, commitShare } from './commit-share';
import { whenGlobalShareClicked } from './when-global-share-clicked';
prepareApi(['bcz_system']);
/**
 * 全局分享 - 分享图文消息
 */
export function globalShare(_a) {
  var onShareClick = _a.onShareClick,
    onShareSend = _a.onShareSend,
    onShareSuccess = _a.onShareSuccess,
    onShareFail = _a.onShareFail,
    shareOption = __rest(_a, ["onShareClick", "onShareSend", "onShareSuccess", "onShareFail"]);
  whenGlobalShareClicked(function () {
    window.bcz_system.onShareSend = function (channelInfo) {
      var channel;
      try {
        channel = channelInfo === null || channelInfo === void 0 ? void 0 : channelInfo['channel'];
      } catch (err) {
        // do nothing
      }
      onShareSend === null || onShareSend === void 0 ? void 0 : onShareSend(channel || 'unknown');
    };
    window.bcz_system.onShare = function (resultStr, channelInfo) {
      try {
        var result = JSON.parse(resultStr);
        if (result['errCode'] === 0) {
          var channel = void 0;
          // iOS 和 Android 回调注入的参数不一致，需要兼容处理
          {
            try {
              // for iOS
              channel = JSON.parse(channelInfo).channel;
            } catch (err) {
              // for Android
              channel = channelInfo;
            }
          }
          onShareSuccess === null || onShareSuccess === void 0 ? void 0 : onShareSuccess(shareChannelMap[channel] || 'unknown');
        } else {
          onShareFail === null || onShareFail === void 0 ? void 0 : onShareFail(new Error(resultStr));
        }
      } catch (err) {
        onShareFail === null || onShareFail === void 0 ? void 0 : onShareFail(err);
      }
    };
    onShareClick === null || onShareClick === void 0 ? void 0 : onShareClick();
    commitShare(shareOption);
  });
}
/**
 * 全局分享 - 分享图片
 */
export function globalShareImage(shareOption) {
  return globalShare(__assign(__assign({}, shareOption), {
    shareType: 'image'
  }));
}
/**
 * 全局分享 - 分享文字
 */
export function globalShareText(shareOption) {
  return globalShare(__assign(__assign({}, shareOption), {
    shareType: 'text'
  }));
}
/**
 * 全局分享 - 分享小程序
 */
export function globalShareMiniProgram(shareOption) {
  return globalShare(__assign(__assign({}, shareOption), {
    shareType: 'mini-program'
  }));
}